<template>
    <div class="mainx">
        <BaseHeader title="Recusas do cartão de crédito"></BaseHeader>
        <b-breadcrumb
            :items="[{ text: 'Dashboard', href: '/dashboard' }, { text: $t('views.seller.reports.text_1428'), href: '/relatorios' }, { text: 'Recusas do cartão de crédito' }]"
            class="bg-white m-0 p-0"></b-breadcrumb>
        <div class="divider"></div>
        <div class="container-x">
            <FilterExport hide-export />
            <div class="box-stateless" style="padding: 32px">
                <CreditCardResume subtitle="Total de recusas" :labels="chart_data ? Object.keys(chart_data) : []"
                    :data="chart_data ? Object.values(chart_data) : []">
                    <template v-slot:extra>
                        <div class="label">
                            <BigNumber title="Vendas recuperadas (venda inteligente)" :value="counter_smart_sales" size="md">
                                <template v-slot:tooltip>
                                    <InfoTooltip
                                        label="Vendas originalmente recusadas que foram convertidas pelo processo de venda inteligente" />
                                </template>
                            </BigNumber>
                        </div>
                        <div class="label">
                            <BigNumber title="Vendas inteligentes recusadas" :value="counter_smart_sales_refused" size="md">
                                <template v-slot:tooltip>
                                    <InfoTooltip
                                        label="O processo de venda inteligente tentou recuperar a venda, porém também foi recusado" />
                                </template>
                            </BigNumber>
                        </div>
                    </template>
                </CreditCardResume>
            </div>
            <div class="container-table">
                <div class="box-stateless">
                    <TableReport
                        :columns="columns"
                        :rows="data"
                        :isLoading="loading"
                    />
                    <div v-if="data.length > 0" class="d-flex align-items-center justify-content-end" style="border-top: 1px solid #dee2e6; height: 80px; margin-bottom: 10px;">
                        <Paginate
                            :totalPages="pagination.totalPages"
                            :activePage="pagination.currentPage"
                            @to-page="toPage"
                            @per-page="perPage"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import TableReport from "@/components/Seller/Reports/TableReport.vue";
import ReportService from "@/services/resources/ReportService";
import FilterExport from './FilterExport.vue';
import CreditCardResume from '@/components/Seller/Reports/CreditCardResume.vue';
import BigNumber from '@/components/Seller/Reports/BigNumber.vue';
import InfoTooltip from '@/components/Seller/Reports/InfoTooltip.vue';
import Paginate from '@/components/shared/Paginate';
import { debounce } from 'lodash';

const Report = ReportService.build();

export default {
    components: {
        BaseHeader,
        TableReport,
        FilterExport,
        CreditCardResume,
        BigNumber,
        InfoTooltip,
        Paginate
    },
    data() {
        return {
            data: [],
            columns: [
                { type: 'status', fieldName: 'sale_status' },
                { type: 'link', fieldName: 'sale_id', path: '/vendas?s_id=' },
                { type: 'status', fieldName: 'subscription_status' },
                { type: 'link', fieldName: 'subscription_id', path: '/contratos?c_id=' },
                { type: 'text', fieldName: 'client_name' },
                { type: 'text', fieldName: 'document' },
                { type: 'email', fieldName: 'client_email' },
                { type: 'phone', fieldName: 'client_phone' }
            ],
            chart_data: null,
            loading: false,
            counter_smart_sales: 0,
            counter_smart_sales_refused: 0,
            pagination: {
                totalPages: 1,
                currentPage: 1,
                perPage: 10
            }
        };
    },
    computed: {
        filter() {
            return this.$store.getters.getFilters;
        }
    },
    methods: {
        debounce: debounce(function() {
            this.fetchReport();
        }, 500),
        toPage(page) {
            this.pagination.currentPage = page;
            this.fetchReport();
        },
        perPage(qtd) {
            this.pagination.currentPage = 1;
            this.pagination.perPage = qtd;
            this.fetchReport();
        },
        fetchReport() {
            this.loading = true;

            let data = {
                type: "full",
                page: this.pagination.currentPage,
                per_page: this.pagination.perPage,
            };

            // Limpa filtros vazios
            let filters = { ...this.filter };
            Object.keys(filters).forEach(
                (key) =>
                    (filters[key] == null || filters[key].length === 0) &&
                    delete filters[key]
            );

            // Combina os dados de paginação com os filtros
            data = Object.assign(data, filters);

            Report.search({ url: "sales-refused", ...data })
                .then((response) => {
                    this.pagination.currentPage = response.currentPage;
                    this.pagination.lastPage = response.lastPage;
                    this.pagination.perPage = response.perPage;
                    this.pagination.totalPages = Math.ceil(response.total / response.perPage);

                    this.data = response['sales'];
                    this.chart_data = response['chart_data'];
                    this.counter_smart_sales = response['sales_smart_sale'];
                    this.counter_smart_sales_refused = response['sales_smart_sale_refused'];
                    this.loading = false;
                })
                .finally(() => {
                    this.loading = false;
                });;
        }
    },
    created() {
        this.fetchReport();
    }
};
</script>

<style scoped>
.box-stateless {
    border: 1px solid #D7DAE2;
    box-sizing: border-box;
    border-radius: 8px;
    width: 100%;
    max-width: 1660px;
}

.container-x {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding-bottom: 24px;
}
</style>